<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Dostop za uporabnika {{ user.moniker }}
    </h2>

    <h2 class="small-h2">
      Novo geslo:
    </h2>
    <ResetPasswordForm
      @save="resetPassword"
    />

    <h2 class="small-h2">
      Nov pin:
    </h2>
    <ResetPinForm
      @save="resetPin"
      @cancel="cancel"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ResetPasswordForm from '@/components/ResetPasswordForm'
import ResetPinForm from '@/components/ResetPinForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  components: {
    ResetPasswordForm,
    ResetPinForm
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    id: {
      required: true,
      type: Number
    }
  },
  computed: {
    ...mapGetters('auth', ['childCompanyUserIsTaken']),
    user () {
      return this.$store.state.users.items[this.id]
    },
    usersRouteName () {
      return this.childCompanyUserIsTaken ? 'MyCompanyUsers' : 'Users'
    }
  },
  methods: {
    ...mapActions('users', ['loadItem', 'savePassword', 'savePin']),
    resetPassword ({ data }) {
      this.savePassword({ data, userId: this.id })
        .then(item => {
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
          this.$router.push({ name: this.usersRouteName })
        })
    },
    resetPin ({ data }) {
      this.savePin({ data, userId: this.id })
        .then(item => {
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
          this.$router.push({ name: this.usersRouteName })
        })
    },
    cancel () {
      this.$router.push({ name: this.usersRouteName })
    }
  },
  created () {
    this.loadItem(this.id)
      .then(values => {
        this.asyncDataStatus_fetched()
      })
  }
}
</script>

<style lang="scss" scoped>
.small-h2 {
  font-size: 1.3em;
}
</style>
